<template>
    <div id="pending-reservation-content">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <span class="page-title" id="vehiclegroupHeader">Reservation Details</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackPendingReservationList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content reservation-details">
                        <section class="internal-container border-top-table-fl">
                            <template v-for="(BookData, key) in RentedTrucksArr">
                                <div class="details-page-container view-details-page-container" :key="key">
                                    <div class="form-row">
                                        <div class="col-md-6">
                                            <div class="title">Customer Name :</div>
                                            <span class="mt-2 display-block">{{BookData.company_name}}</span>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="title">Phone :</div>
                                            <span class="mt-2 display-block">{{formatPhoneNumber(BookData.user_phone)}}</span>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="title">Email :</div>
                                            <span class="mt-2 display-block">{{BookData.user_username}}</span>
                                        </div>
                                    </div>
                                    <lable class="color-red" v-if="BookData.cancelled == 1">Reservation Cancelled</lable>
                                        <div class="reserved-vehicle-info mt-3">
                                            <template v-for="(truckData, tkey) in RentedTrucksArr[key]['trucks']">
                                                <a :key="tkey" class="truck-badge mt-3 ml-lg-3 mr-3" :id="'truck_badge_'+truckData.reservId" href="javascript:void(0)" v-on:click="GetTruckData(truckData.reservId)">
                                                    <div class="admin-truck-img">
                                                        <template v-if="truckData.image != ''">
                                                        <template v-for="(truckImage, key) in truckData.image" >
                                                            <div v-if="truckImage.url != ''" class="" :key="key">
                                                                <img v-bind:src="truckImage.url" alt="" v-if="truckImage.url != ''">
                                                            </div>
                                                            <div v-if="truckImage.url == ''" class="" :key="key">
                                                                <img src="/static/images/truck-img.jpg" alt="">
                                                            </div>
                                                        </template>
                                                        </template>
                                                        <template v-else>
                                                            <img src="/static/images/truck-img.jpg" alt="">
                                                        </template>
                                                    </div>
                                                    <div class="admin-truck-text">
                                                        <span>{{ truckData.type_name }}</span>
                                                        <div class="selected-truck-date">
                                                            <p>From: {{ truckData.from_date[0] }}</p>
                                                            <p class="text-right">To: {{ truckData.to_date[0] }}</p>
                                                        </div>
                                                    </div>
                                                </a>
                                            </template>
                                        </div>
                                        <template v-for="(tData, trkey) in TrucksArr">
                                        <div :key="trkey" class="reserved-details">
                                            <div class="reserved-vehicle-details p-lg-4 p-3">
                                                <lable style="color:green" v-if="tData.settle_status == 1">Reservation Settled</lable>
                                                <div class="top-enrich-section" style="width:100%;">
                                                    <label class="mr-2">Current Status:</label><span v-show="enrichStatusSpan" class="current-status">&nbsp;{{ tData.resStatus }}</span>
                                                    <div class="enrich-input-tab">
                                                        <a href="javascript:void(0)" title="Update" v-show="editStatusInput" v-on:click="CurrentStatus =  tData.resStatus, viewStatusInput = true, editStatusInput = false,enrichStatusSpan = false" v-if="adminCan && canChangeReservationStatus"><i class="fp-edit" aria-hidden="true"></i></a>
                                                        <div class="enrich-input" v-show="viewStatusInput">
                                                            <v-select v-model="CurrentStatus" class="custom-vselect" id="statusInput" label="text" :options="statusArr"></v-select>
                                                            <button class="btn btn-primary" id="updateStatusBtn" v-on:click="updateReservationDetail(tData.reservationId,tData.id,'status')">Save</button>
                                                            <a class="close-input" href="javascript:void(0)" v-on:click="viewStatusInput = false, editStatusInput = true, enrichStatusSpan = true, statusErr = ''"><i class="fp-add" aria-hidden="true"></i></a>
                                                            <div class="field-error">{{statusErr}}</div>
                                                        </div>
                                                    </div>
                                                    <div v-if="tData.credit_override_request_status != ''">
                                                        <label class="">Credit Override Req. Status:</label>
                                                        <span class="col"><span v-if="tData.credit_override_request_status == 'sent'" class="badge badge-warning">{{ titleCase(tData.credit_override_request_status) }}</span>
                                                        <span v-if="tData.credit_override_request_status == 'approved'" class="badge badge-success">{{ titleCase(tData.credit_override_request_status) }}</span>
                                                        <span v-if="tData.credit_override_request_status == 'denied'" class="badge badge-danger">{{ titleCase(tData.credit_override_request_status) }}</span>
                                                        </span>
                                                    </div>
                                                    <!-- v-if="tData.cancelled != 1 && tData.resStatus == 'Active' && !tData.agreement_id && tData.contractType.toLowerCase() == 'rental'" -->
                                                    <button v-if="tData.cancelled != 1 && tData.resStatus == 'Pending' && !tData.agreement_id && tData.contractType.toLowerCase() == 'rental' && (tData.credit_override_request_status == '' || tData.credit_override_request_status == 'approved')" type="submit" class="btn btn-primary pull-right" v-on:click.prevent="createAgreement(tData.reservationId)">
                                                        Create Agreement
                                                    </button>
                                                </div>
                                                <div class="mt-4">
                                                    <span class="reference-number ">
                                                        Reservation #: <span v-show="enrichTransNoSpan">{{tData.reference_no}}</span>
                                                    </span>
                                                    <div class="top-enrich-section" v-show="viewEnrichInput">
                                                        <input v-model="enrichRefNo" type="text" class="form-control">
                                                        <button class="btn btn-primary" id="updateTransBtn" v-on:click="updateReservationDetail(tData.reservationId,tData.id,'ref_num')">Save</button>
                                                        <a class="close-input" href="javascript:void(0)" v-on:click="viewEnrichInput = false, editEnrichInput = true, enrichTransNoSpan = true, refError= ''"><i class="fp-add" aria-hidden="true"></i></a>
                                                        <div class="field-error">{{refError}}</div>
                                                    </div>
                                                </div>
                                                <div class="flexibility-details">
                                                    <span>Flexible Location: {{tData.flex_location}}</span>
                                                    <span>Flexible Date: {{tData.flex_date}}</span>
                                                </div>

                                                <div class="edit-delete-icons">
                                                    <a :key="key" class="pull-right edit-icon" href='javascript:void(0)' v-on:click="updateReservation(tData.reservationId)">
                                                        <i class="fp-edit color-blue"></i>
                                                    </a>
                                                    <a class="pull-right delete-icon mr-3" href="javascript:void(0)" v-on:click="deleteSelectedTruck(tData.reservationId, tData.id , $event)" v-if="canCancelReservation && tData.status == 0 && !readingToken">
                                                        <i class="fp-delete color-red"></i>
                                                    </a>
                                                </div>
                                                <div class="rental-truck-block mt-2 mb-3 pull-left">
                                                    <div class="rental-period-border">
                                                        <i class="fp-truck" aria-hidden="true"></i>
                                                    </div>
                                                    <div class="location pull-left">
                                                        <span><b class="font-bold color-black">From:</b> {{tData.fromLocation}}</span>
                                                        <p>{{tData.pickup_date}} {{tData.pickup_time}}</p>
                                                    </div>
                                                    <div class="location pull-right text-right">
                                                        <span><b class="font-bold color-black">To:</b> {{tData.toLocation}}</span>
                                                        <p class="text-right">{{tData.dropoff_date}} {{tData.dropoff_time}}</p>
                                                    </div>
                                                </div>
                                                <div class="order-summary-block row no-gutters">
                                                    <div class="col-md-8">
                                                        <div class="row no-gutters">
                                                            <div class="img-container col-md-5 mb-3" v-if="tData.truck_image != ''">
                                                                <template v-for="(truckImage, key) in tData.truck_image" >
                                                                    <div v-if="truckImage.url != ''" class="os-truck-img" :key="key">
                                                                        <img v-bind:src="truckImage.url" alt="" v-if="truckImage.url != ''">
                                                                    </div>
                                                                    <div v-if="truckImage.url == ''" class="os-truck-img" :key="key">
                                                                        <img src="/static/images/truck-img.jpg"  alt="">
                                                                    </div>
                                                                </template>
                                                            </div>
                                                            <div class="img-container col-md-5 mb-3" v-else>
                                                                <img src="/static/images/truck-img.jpg" alt="">
                                                            </div>
                                                            <div class="truck-info col-md-7 pl-lg-4 mb-3">
                                                                <h3 class="font-semibold">{{tData.truckTypeName}}</h3>
                                                                <p class="truck-quntity-rt"> {{tData.quantity + " Qty"}} </p>
                                                                <div class="new-price-container mt-3 mb-3">
                                                                    <div class="price">
                                                                        <p>Estimated Miles :</p>
                                                                        <div class="new-price">
                                                                            {{tData.miles}} <span>Miles</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="price mt-3">
                                                                        <p>Actual Miles :</p>
                                                                        <div class="new-price">
                                                                            {{tData.distance}} <span>Miles</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="pickup-address">
                                                                    <div class="address-title">Location</div>
                                                                    <div class="address">
                                                                        <template v-if="tData.addressLine1 != ''">
                                                                        {{tData.addressLine1}},<br>
                                                                        </template>
                                                                        <template v-if="tData.addressLine2 != ''">
                                                                            {{tData.addressLine2}},<br>
                                                                        </template>
                                                                        {{tData.city}}, {{tData.state}} &nbsp;
                                                                        {{tData.zip}}<br>
                                                                        {{tData.phone}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="detail-description">
                                                            <template v-for="(othrateArr , othratekey) in TrucksArr[trkey]['other_rates']">
                                                                <div :key="othratekey" class="table-view-detail">
                                                                    <div class="left-section" v-if="othrateArr.name === 'government_compliance'">Govt. Compliance Fee :
                                                                        <div class="os-estimated-hours">
                                                                            $ {{numberFormat(othrateArr.rate) + " X " + othrateArr.unit + ' ' + othrateArr.type}}
                                                                        </div>
                                                                    </div>
                                                                    <div class="left-section" v-if="othrateArr.name === 'ENV'">Env. Compliance Fee:
                                                                        <div class="os-estimated-hours">
                                                                            $ {{numberFormat(othrateArr.rate) + " X " + othrateArr.unit + ' ' + othrateArr.type}}
                                                                        </div>
                                                                    </div>
                                                                    <div class="left-section" v-else-if="othrateArr.rate_type">{{othrateArr.rate_type}} :
                                                                        <div class="os-estimated-hours">
                                                                            $ {{numberFormat(othrateArr.rate) + " X " + othrateArr.unit + ' ' + othrateArr.type}}
                                                                        </div>
                                                                    </div>
                                                                    <div class="left-section" v-else-if="othrateArr.section">{{othrateArr.section}} :
                                                                        <div class="os-estimated-hours">
                                                                            $ {{numberFormat(othrateArr.rate) + " X " + othrateArr.unit + ' ' + othrateArr.type}}
                                                                        </div>
                                                                    </div>
                                                                    <div class="left-section" v-else>{{othrateArr.name}} :
                                                                        <div class="os-estimated-hours">
                                                                            $ {{numberFormat(othrateArr.rate) + " X " + othrateArr.unit + ' ' + othrateArr.type}}
                                                                        </div>
                                                                    </div>
                                                                    <div class="right-section">$ {{ numberFormat(othrateArr.total)}}</div>
                                                                </div>
                                                            </template>
                                                            <div class="table-view-detail" v-if="TrucksArr[trkey]['insurance_rates']['phy_ins_charge'] != ''">
                                                                <div class="left-section">Physical Insurance :
                                                                    <div class="os-estimated-hours">
                                                                        $ {{numberFormat(TrucksArr[trkey]['insurance_rates']['phy_ins_charge']['rate']) + " X " + TrucksArr[trkey]['insurance_rates']['phy_ins_charge']['days'] + ' ' + TrucksArr[trkey]['insurance_rates']['phy_ins_charge']['type']}}
                                                                    </div>
                                                                </div>
                                                                <div class="right-section">$ {{numberFormat(TrucksArr[trkey]['insurance_rates']['phy_ins_charge']['total'])}}</div>
                                                            </div>
                                                            <div class="table-view-detail" v-if="TrucksArr[trkey]['insurance_rates']['lia_ins_charge'] != ''">
                                                                <div class="left-section">Liability Insurance :
                                                                    <div class="os-estimated-hours">
                                                                        $ {{numberFormat(TrucksArr[trkey]['insurance_rates']['lia_ins_charge']['rate']) + " X " + TrucksArr[trkey]['insurance_rates']['lia_ins_charge']['days'] + ' ' + TrucksArr[trkey]['insurance_rates']['lia_ins_charge']['type']}}
                                                                    </div>
                                                                </div>
                                                                <div class="right-section">$ {{numberFormat(TrucksArr[trkey]['insurance_rates']['lia_ins_charge']['total'])}}</div>
                                                            </div>
                                                            <div class="table-view-detail" v-if="TrucksArr[trkey]['insurance_rates'].admin_fee != 0">
                                                                <div class="left-section">Admin Fee :</div>
                                                                <div class="right-section">$ {{ numberFormat(TrucksArr[trkey]['insurance_rates'].admin_fee) }}</div>
                                                            </div>
                                                            <div class="table-view-detail" v-if="TrucksArr[trkey].tax != null">
                                                                <div class="left-section">Tax &nbsp; (5%) :</div>
                                                                <div class="right-section">$ {{ numberFormat(TrucksArr[trkey].tax) }}</div>
                                                            </div>
                                                            <template class="table-view-detail" v-for="(charges,chargekey) in TrucksArr[trkey]['charges']">
                                                                <div :key="chargekey" class="table-view-detail">
                                                                    <div class="left-section">{{charges.detail}} :</div>
                                                                    <div class="right-section">$ {{ numberFormat(charges.amount)}}</div>
                                                                </div>
                                                            </template>
                                                            <div class="total-block" v-if="tData.total > 0">
                                                                <div class="section pull-left">
                                                                    Estimated Subtotal :
                                                                </div>
                                                                <div class="section pull-right">
                                                                    $ {{ numberFormat(tData.estimated_sub_total) }}
                                                                </div>
                                                            </div>
                                                            <div v-else class="total-block">
                                                                <div class="section">
                                                                    Charges Not Available
                                                                </div>
                                                            </div>
                                                            <div class="total-block mt-2" v-if="tData.total > 0">
                                                                <div class="section pull-left">
                                                                    Estimated Total : <br/>
                                                                    <small> {{ tData.quantity + " Qty X"}}  $ {{ numberFormat(tData.estimated_sub_total)}} </small>
                                                                </div>
                                                                <div class="section pull-right">
                                                                    $ {{ numberFormat(tData.total) }}
                                                                </div>
                                                            </div>
                                                            <div v-else>
                                                                <div class="total-block">
                                                                    Charges Not Available
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="insurance-deatils mt-4" >
                                                <h4>Insurance</h4>
                                                <div class="insurance-block p-lg-4 p-3">
                                                    <div class="radio-selection border-bottom pb-2 mb-3">
                                                        <label class="pr-3">Physical Damage & Liability Insurance</label>
                                                        <div class="custome-radiobtn form-check-inline">
                                                            <div class="form-check form-check-inline">
                                                                <label class="boolean optional radio-custom" for="provide_ins"> Provide Insurance
                                                                    <input type="radio" v-model="insuranceType" :value="1" name="is_default" id="provide_ins" disabled> <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                            <div class="form-check form-check-inline">
                                                                <label id="depriciable2_item" class="boolean optional radio-custom" for="purchase_ins"> Purchase Insurance
                                                                    <input type="radio" v-model="insuranceType"  :value="0" name="is_default" id="purchase_ins" disabled> <span class="checkmark"></span>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <template v-if="phyfromTheir">
                                                        <div class="form-row row-cols-md-4 row-cols-1">
                                                            <div class="col form-group" v-if="comSelect">
                                                                <label class="control-label">Insurance Policies : </label>
                                                                <v-select placeholder="Select Insurance Policy" v-model="insCompany" label="text" :options="companyArr" disabled></v-select>
                                                            </div>
                                                            <div class="col form-group">
                                                                <label class="control-label require">Company Name : </label>
                                                                <v-select v-model="phyCompanyName" :searchable="phyCompanyDisabled" name="checkUser"
                                                                        label="text" :filterable="false" :options="AllcompanyArr"
                                                                        @search="onSearch" disabled
                                                                        placeholder="Select Insurance Company" class="custom-ci-auto-search">
                                                                    <template slot="no-options">
                                                                        Search Insurance Company...
                                                                    </template>
                                                                    <template slot="option" slot-scope="option">
                                                                        <div class="d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                    </template>
                                                                    <template slot="selected-option" slot-scope="option">
                                                                        <div class="selected d-center">
                                                                            {{ option.text }}
                                                                        </div>
                                                                    </template>
                                                                </v-select>
                                                                <div class="field-error" >{{ phycompanyerrors }}</div>
                                                            </div>
                                                            <div class="col form-group">
                                                                <label class="control-label require">Contact Number : </label>
                                                                <!-- <input  v-model.trim="phyContactNo" class="form-control" :disabled="phyContactDisabled == 1" name="ContactNumber" type="text"
                                                                        placeholder="Contact Number"> -->
                                                                    <input  v-model.trim="phyContactNo" class="form-control" disabled name="ContactNumber" type="text"
                                                                         placeholder="Contact Number">
                                                                <div class="field-error" >{{ phynumbererrors }}</div>
                                                            </div>
                                                            <div class="col form-group">
                                                                <label class="control-label require">Contact Name : </label>
                                                                <!-- <input v-model.trim="phyContactName" class="form-control" :disabled="phyContactNameDisabled == 1" name="ContactNumber" type="text"
                                                                    placeholder="Contact Name"> -->
                                                                <input v-model.trim="phyContactName" class="form-control" disabled name="ContactNumber" type="text"
                                                                placeholder="Contact Name">
                                                                <div class="field-error">{{ phycontacterror }}</div>
                                                            </div>
                                                            <div class="col form-group">
                                                                <label class="control-label">Email : </label>
                                                                <!-- <input v-model.trim="phyEmail" class="form-control ins" :disabled="phyEmailDisabled == 1" name="ContactNumber" type="text"
                                                                    placeholder="Contact Email"> -->
                                                                    <input v-model.trim="phyContactName" class="form-control" disabled name="ContactNumber" type="text"
                                                                    placeholder="Contact Name">
                                                                <div class="field-error" >{{ phyemailerrors }}</div>
                                                            </div>
                                                            <div class="col form-group">
                                                                <label class="phyfromtheircompany control-label">Policy Number : </label>
                                                                <!-- <input v-model.trim="phyPolicyNo" class="form-control ins" :disabled="phyPolicyNoDisabled == 1" name="Policy" type="text"
                                                                    placeholder="Policy Number"> -->
                                                                  <input v-model.trim="phyPolicyNo" class="form-control ins" disabled name="Policy" type="text"
                                                                    placeholder="Policy Number">
                                                                <div class="field-error" >{{ phypolicyerrors }}</div>
                                                            </div>
                                                        </div>
                                                        <div class="form-row">
                                                            <div class="col">
                                                                <div class="document-upload tab-section">
                                                                    <label class="pb-2 mb-3">Documents :</label>
                                                                    <template v-if="TrucksArr[trkey]['phyinsfiles'][0]">
                                                                        <template v-if="TrucksArr[trkey]['phyinsfiles'][0]['from_their']">
                                                                            <div class="row row-cols-md-6 row-cols-1">
                                                                            <template v-for="(fileinsData, fileskey) in TrucksArr[trkey]['phyinsfiles'][0]['from_their']">
                                                                                <div class="col" :key="'insrFromUsFile'+fileskey" v-if="fileinsData.display_name != ''">
                                                                                    <div class="thumbnail-inspection-img">
                                                                                        <a href="javascript:void(0)" v-if="fileinsData.extension == 'doc'">
                                                                                            <iframe :src="'https://docs.google.com/viewer?url='+ fileinsData.url+'&embedded=true'" title="" width="150px;" height='150px;'></iframe>
                                                                                        </a>
                                                                                        <a href="javascript:void(0)"  v-on:click="viewFile(fileinsData.id,fileinsData.url,'from_their')" v-else>
                                                                                            <img :src="fileinsData.url" :alt="fileinsData.display_name" width="150px;" height='150px;'/>
                                                                                        </a>
                                                                                        <i v-on:click="deleteInsuranceFile(fileinsData.id, tData.reservationId, tData.id)" class="fp-add rotate-45" aria-hidden="true" ></i>
                                                                                    </div>
                                                                                </div>
                                                                            </template>
                                                                            </div>
                                                                        </template>
                                                                        <template v-else>
                                                                            <span class='display-block mb-3'>No Data Found.</span>
                                                                        </template>
                                                                    </template>
                                                                    <template v-else>
                                                                        <span class='display-block mb-3'>No Data Found.</span>
                                                                    </template>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- <div class="btn-groups">
                                                            <div class="custom-upload-container ml-0" data-provides="fileupload" v-if="phyDocumentShow">
                                                                <label for="physicalFiles" class="btn btn-secondary mb-0"> <i class="fp-upload"> </i> Upload</label>
                                                                <label for="physicalFiles" class="hide btn btn-secondary">Change</label>
                                                                <input class="hide" type="file" id="physicalFiles" ref="phyFiles" multiple v-on:change="handleinsFilesUpload('physical')"/>
                                                            </div>
                                                            <a class="btn btn-primary" href="javascript:void(0)" v-on:click="submitFiles(0,'from_their',BookData.bookingId,tData.reservationId,tData.pickup_date,tData.dropoff_date)">
                                                                <i class="fp-submit"> </i> Submit
                                                            </a>
                                                        </div>
                                                        <template v-if="phyDocumentShow">
                                                            <div class="form-row row-cols-md-4 row-cols-1">
                                                                <template v-for="(file, key) in insfile">
                                                                    <div v-bind:key="key" class="file-container col" :id="'fileDiv'+file.id">
                                                                        <span class="fileupload-preview">{{ file.name }}</span>
                                                                        <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteInsuranceDoc(file.id,key,'physical')" style="float: right">
                                                                            <i class="fp-remove"></i>
                                                                        </a>
                                                                    </div>
                                                                </template>
                                                            </div>
                                                        </template>
                                                        <span class="field-error">{{ phyDocerrors }}</span> -->
                                                    </template>
                                                    <template v-if="!phyfromTheir" >
                                                        <div class="document-upload">
                                                            <div class="tab-section">
                                                                <template  v-if="insuranceRates['phy_ins_charge'].length > 0 || insuranceRates['lia_ins_charge'].length > 0 || insuranceRates['admin_fee'] > 0">
                                                                    <label class="control-label pb-2 mb-3" for="charges_title" >Charges:</label>
                                                                    <div class="table-responsive">
                                                                        <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                                                            <thead>
                                                                                <tr class="table-primary">
                                                                                    <th scope="col" style="width:10px;">Charge Name</th>
                                                                                    <th scope="col">Days</th>
                                                                                    <th scope="col">Charge</th>
                                                                                    <th scope="col">Total</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <template v-for="(row, index) in insuranceRates">
                                                                                    <tr v-if="index=='phy_ins_charge' && row!=''" :key="index">
                                                                                        <td scope="col" style="width:10px;">Physical Insurance :</td>
                                                                                        <td scope="col">{{row['days']}} Days</td>
                                                                                        <td scope="col">${{numberFormat(row['rate'])}}</td>
                                                                                        <td scope="col">${{numberFormat(row['total'])}}</td>
                                                                                    </tr>
                                                                                    <tr v-if="index=='lia_ins_charge' && row!=''" :key="index">
                                                                                        <td scope="col" style="width:10px;">Liability Insurance :</td>
                                                                                        <td scope="col">{{row['days']}} Days</td>
                                                                                        <td scope="col">${{numberFormat(row['rate'])}}</td>
                                                                                        <td scope="col">${{numberFormat(row['total'])}}</td>
                                                                                    </tr>
                                                                                    <tr v-if="index=='admin_fee' && row > 0" :key="index">
                                                                                        <td scope="col" style="width:10px;">Admin Fee:</td>
                                                                                        <td scope="col">-</td>
                                                                                        <td scope="col">-</td>
                                                                                        <td scope="col">${{numberFormat(row)}}</td>
                                                                                    </tr>
                                                                                </template>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </template>
                                                                <template v-else>
                                                                    <span class='noInsFile'>No Charges found.</span>
                                                                </template>
                                                                <!-- <template v-if="TrucksArr[trkey]['phyinsfiles'] && TrucksArr[trkey]['phyinsfiles'][0] && TrucksArr[trkey]['phyinsfiles'][0]['from_us']">
                                                                    <div class="row row-cols-md-6 row-cols-1">
                                                                        <template v-for="(fileinsData, fileskey) in TrucksArr[trkey]['phyinsfiles'][0]['from_us']">
                                                                            <div class="col" :key="'insrFromUsFile'+fileskey" v-if="fileinsData.name != ''">
                                                                                <div class="thumbnail-inspection-img">
                                                                                    <a href="javascript:void(0)" v-if="fileinsData.extension == 'doc'">
                                                                                        <iframe :src="'https://docs.google.com/viewer?url='+fileinsData.url+'&embedded=true'" width="150px;"  title="" height='150px;'></iframe>
                                                                                    </a>
                                                                                    <a href="javascript:void(0)"  v-on:click="viewFile(fileinsData.id,fileinsData.url,'from_us')" v-else>
                                                                                        <img :src="fileinsData.url" :alt="fileinsData.display_name" width="150px;" height='150px;'/>
                                                                                    </a>
                                                                                     <i v-on:click="deleteInsuranceFile(fileinsData.id, tData.reservationId, tData.id )" class="fp-add rotate-45" aria-hidden="true" ></i>
                                                                                </div>
                                                                            </div>
                                                                        </template>
                                                                    </div>
                                                                </template>
                                                                <template v-else>
                                                                    <span class='display-block mb-3'>No document found.</span>
                                                                </template> -->
                                                            </div>
                                                            <!-- <div class="btn-groups">
                                                                <div class="custom-upload-container ml-0" data-provides="fileupload">
                                                                    <label for="documentsUpload" class="btn btn-secondary"> <i class="fp-upload"> </i> Upload</label>
                                                                    <input class="hide" id="documentsUpload" type="file" @change="handleDocUpload" multiple>
                                                                </div>
                                                                <a v-show="adminCan" class="btn btn-primary" href="javascript:void(0)" v-on:click="submitFiles(0,'from_us',BookData.bookingId,tData.reservationId,tData.pickup_date,tData.dropoff_date)">
                                                                    <i class="fp-submit"> </i> Submit
                                                                </a>
                                                            </div>
                                                            <div class="form-row row-cols-md-4 row-cols-1">
                                                                <template v-for="(file, key) in selectedFile">
                                                                    <div v-bind:key="key" class="file-container col" :id="'fileDiv'+file.id">
                                                                        <span class="fileupload-preview">{{ file.name }}</span>
                                                                        <a href="javascript:void(0)" :class="'close'" data-dismiss="fileupload" v-on:click="deleteFromUsDoc(key)" style="float: right">
                                                                            <i class="fp-remove"></i>
                                                                        </a>
                                                                    </div>
                                                                </template>
                                                                <div class="field-error">{{ insDocerrors }}</div>
                                                            </div> -->
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                            <div class="modal fade invoice-modal" id="pre_auth_amount_modal" ref="preAuthAmount" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">Update Pre-Auth Amount</h5>
                                        </div>
                                        <div class="modal-body">
                                            <form id="SelectDates" class="form-inline addinspectionForm">
                                                <div class="form-row">
                                                    <input type="hidden" v-model="bookingId">
                                                    <input type="hidden" v-model="truckId">
                                                    <div class="col form-group">
                                                        <input v-model="authCharges" name="pre_auth_amount" type="text"
                                                                placeholder="Pre-auth Amount" id="pre_auth_amount" class="form-control text-right">
                                                        <span class="field-error">Pre-auth amount can't be less than the grand total.</span>
                                                        <span class="field-error">{{error}}</span>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        <div class="modal-footer">
                                            <button class="btn btn-primary" id="myButton" v-on:click="addPreAuthCharges()">Submit</button>
                                            <button type="button" class="btn btn-tertiary" data-dismiss="modal">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal fade invoice-modal" id="invoice_modal" ref="invModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">Invoice</h5>
                                        </div>
                                        <div class="modal-body">

                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-tertiary" data-dismiss="modal">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal fade invoice-modal" id="payCurrentAmount" ref="payCurrentAmount" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">Summary</h5>
                                        </div>
                                        <div class="modal-body">
                                            <form id="SelectDates pay-amnt-rt" class="form-inline addinspectionForm">
                                                <div class="form-row row-cols-md-2 row-cols-1">
                                                     <div class="col form-group">
                                                        <label>Outstanding Amount:</label>
                                                        <span>${{outstandingAmt}}</span>
                                                    </div>
                                                    <div class="col form-group">
                                                        <label>Current Reservation Amount:</label>
                                                        <span>${{currentReservationAmt}}</span>
                                                    </div>
                                                    <div class="col form-group">
                                                        <label>Amount To Pay:</label>
                                                        <input v-model="amounttopay" name="amounttopay" type="text"
                                                            placeholder="Amount To Pay" id="amounttopay" class="form-control text-right">
                                                        <span class="field-error">{{pay_error}}</span>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        <div class="modal-footer">
                                            <button class="btn btn-primary" id="myButton" v-on:click="paymentProcess()" >Pay</button>
                                            <button type="button" class="btn btn-tertiary" data-dismiss="modal" >Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <template v-if="!RentedTrucksArr.length">
                                No Data Found.
                            </template>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import EventBus from ".././event-bus";
    import {commonMixins} from '../../mixins/commonMixins';

    export default {
        name: "viewBooking",
        metaInfo() {
            return {
                title: "Pending Reservation Preview | " +process.env.COPYRIGHT_NAME
            }
        },
        mixins:[commonMixins],
        data: () => ({
            cantAccessPage:"",
            readingOutSpan:[],
            readingOutText:"",
            readingOut:"",
            viewReadingOutInput:false,
            editReadingOutInput:true,
            reading_out_msg:"",
            readingInSpan:true,
            outstandingAmt:"",
            currentReservationAmt:"",
            amounttopay:"",
            readingInText:"",
            amtType:"Estimated",
            readingIn:"",
            fromTheir:"",
            readingToken:false,
            phyfromTheir:"",
            insDocToken:false,
            viewReadingInInput:false,
            editReadingInInput:true,
            reading_in_msg:"",
            enrichTransNoSpan:true,
            enrichTransNoText:"",
            enrichRefNo:"",
            viewEnrichInput:false,
            editEnrichInput:true,
            editStatusInput:false,
            viewStatusInput:false,
            enrichStatusSpan:true,
            view_booking_id: 0,
            CurrentStatus:"",
            statusArr:[{value:"",text:"Select Status"}],
            liaOptions:[{value:'from_their',text:'Having Third Party Insurance' },{
                value:'from_us',text:'Do Not Have Third Party Insurance'
            }],
            bookingData: "",
            fix_rate: "",
            model: "",
            calculate:false,
            submitBtn : false,
            errorDetails:"",
            manufacturer: "",
            chargeId:0,
            miles: "",
            contact:"",
            doc_path:"",
            uploadBtn:'Upload',
            authCharges:"",
            authToken:false,
            rate: "",
            errorothCharges:"",
            RentedTrucksArr:[],
            TrucksArr:[],
            gallons:"",
            fuelRate:"",
            path:"",
            Invoicefile:"",
            invoiceDownPath:"",
            rateName: "",
            invoicePath:"",
            chargesfield :{
                id:0,
                othCharges:"",
                chargesDetails:"",

            },
            chargesFields : [],
            rateType: "",
            bookingId:"",
            doc_fileArr:[],
            fileerroor_msg:"",
            errorgallonsCharges:"",
            truckId:"",
            role:"",
            files:[],
            total: "",
            phynumbererrors:"",
            phycompanyerrors:"",
            phycompanyerror:"",
            phycontacterror:"",
            phyDocerrors:"",
            liacompanyerrors:"",
            liacompanyerror :"",
            liacontacterror:"",
            lianumbererrors:"",
            liaDocerrors:"",
            insDocerrors: "",
            phypolicyerrors:"",
            liapolicyerrors:"",
            phyCompanyName: "",
            phyContactNo: "",
            phyPolicyNo:"",
            liaPolicyNo:"",
            phyFiles: [],
            liaFiles: [],
            pay_error:"",
            liaCompanyName: "",
            editphyCompanyName:true,
            viewEditComForm:false,
            physcompanyName:"",
            editphyContactNum:true,
            viewEditContactForm:"",
            contactNum:"",
            editliaCompanyName:true,
            viewEditliaCompanyForm:false,
            editliaContactNum:true,
            viewliaEditContactForm:false,
            instype:"",
            phyinstype:"",
            phyinstypeArr:[{
                text:'Having Third Party Insurance',
                value:'from_their'
            },
                {
                    text:'Do Not Have Third Party Insurance',
                    value:'from_us'
            }],
            liabcompanyName:"",
            liacontactNum:"",
            liaContactNo: "",
            errors: [],
            modalbtn:"Add",
            error:"",
            errorfuelCharges:"",
            updatefuelcharge:"",
            fuelcharge:"",
            pickupdate: "",
            loading:false,
            insfile:[],
            liafile:null,
            selectedFile:[],
            adminCan: false,
            dropoffdate: "",
            fuelTotal:0,
            othCharges:"",
            truckPath:"",
            chargesDetails:"",
            loggedInUser:"",
            refError:"",
            statusErr:"",
            permissions:[],
            imageUrl:"",
            insuranceType:"",
            comSelect:true,

            phyCompanyDisabled:true,
            // phyContactDisabled:0,
            // phyContactNameDisabled:0,
            // phyEmailDisabled:0,
            // phyPolicyNoDisabled:0,
            phyDocumentShow:true,

            phyContactName:"",
            phyEmail: "",
            phyemailerrors: "",

            insCompany: "",
            companyArr:[{value:"",text:"Select Insurance Company"}],
            AllcompanyArr:[],
            basePath: "",
            reservationId: '',
            canCancelReservation:false,
            canUpdateReservation:false,
            canChangeReservationStatus:false,
            contractType:'',
            pageKey:"",
            insuranceRates:null,
        }),
        watch:{
            insCompany: function(value){

//                console.log('this one'+value.value);

                if(value.value == 0 ){

                    //enable fields
                    this.phyCompanyDisabled = true;
                    // this.phyContactDisabled = 0;
                    // this.phyContactNameDisabled = 0;
                    // this.phyEmailDisabled = 0;
                    // this.phyPolicyNoDisabled = 0;
                    this.phyDocumentShow = true;

                     this.phyCompanyName  = [];
                     this.phyContactName = "";
                     this.phyContactNo = "";
                     this.phyPolicyNo = "";
                     this.phyEmail  = "";

                } else {

                    this.phyPolicyNo  = value.policy;
                    this.phyContactName = value.agent_contact;
                    this.phyEmail = "";
                    this.phyContactNo  = self.formatPhoneNumber(value.agent_phone);
                    this.phyCompanyName = {'value':value.company_id,'text':value.company_name };

                    //disable fields
                    this.AllcompanyArr = [];
                    this.phyCompanyDisabled = false;
                    // this.phyContactDisabled = 1;
                    // this.phyContactNameDisabled = 1;
                    // this.phyEmailDisabled = 1;
                    // this.phyPolicyNoDisabled = 1;
                    this.phyDocumentShow = false;

                }

            },
            insuranceType: function(value){
                if(value == 0){
                    this.phyfromTheir = false;
                }else{
                    this.phyfromTheir = true;
                }
            },
            phyinstype: function(type){
                var self = this;

                if(type.value == 'from_their'){
                    self.phyfromTheir = true;
                    self.fromTheir = true;
                    self.phyinstype.value = 'from_their';
                    self.instype = {value : 'from_their',text : "Having Third Party Insurance"};
                }else{
                    self.phyfromTheir = false;
                    self.phyinstype.value = 'from_us';
                }
            },

            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'view_reservation') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'make_payment') {
                            self.canPay = true;
                        }
                        if (permissions[i].name == 'cancel_reservation') {
                            self.canCancelReservation = true;
                        }
                        if (permissions[i].name == 'add_reservation') {
                            self.canUpdateReservation = true;
                        }
                        // if (permissions[i].name == 'change_pending_reservation_status') {
                        //     self.canChangeReservationStatus = true;
                        // }//disable edit reservation status feature
                    }
                }
            },

        },

        mounted: function() {

            var self = this;

            self.fuelTotal = self.fuelRate * self.gallons;
            var path =  process.env.ROOT_API;

            var imgPath = path.split('/');
//            console.log(imgPath);

            self.basePath = imgPath[0]+'//'+imgPath[2];

            self.path = process.env.FOLDER_URL + "/chargesDoc/";
            self.truckPath = process.env.FOLDER_URL + "/trucktypeimages/";
            self.invoiceDownPath = process.env.FOLDER_URL + "/invoices/";
            self.imageUrl = process.env.FOLDER_URL;
            //check that page is add or update
            this.view_booking_id = this.$route.params.id;
            this.pageKey='_pending_reservation_view_'+this.view_booking_id;
            //check user loggged in or not
            var userObj = localStorage.getItem("user_obj");

            //if user logged in than remove login button and registration button
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                if (userJson.roles.length > 0) {
                    this.role = userJson.roles[0].name;

                }
                self.loggedInUser = userJson.id;
                //EventBus.$emit("logged-in", false, userJson["contact"], this.role);
            }

            if(this.role != 'customer'){
                this.adminCan = true;
            }
            //populate rental detail
            this.getBookingDetails();
            //set the page is not profile page
            EventBus.$emit("profile", false);

            // this.viewInvoice(this.view_booking_id);
            this.getPermissions();
            this.getReservationStatus();

        },
        methods:{

            createAgreement: function(id){

                var self = this;

                self.$router.push("/rentalagreement/add?penresId="+id)
            },

            onSearch(search, loading)
            {
                if (search.length > 1) {
                    loading(true);
                    this.getInsuranceCompany(loading, search, this);
                }
            },
            getInsuranceCompany: function(loading, search){
                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/get_insurance_company",
                    type: "GET",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    data:{field:search},
                    dataType: "json",
                    success: function (data) {
                            loading(false);
                        if (data.status == "success") {

                            self.AllcompanyArr = data.content;

                        }
                    },
                    error: function (jqXHR, exception) {
                        loading(false);
                        // $("#settle-btn-"+paymentId).html("<button @click='settlePayment(BookData.bookingId,payment.id)' class=\"btn btn-primary\">Settle Payment</button>");
                        self.generateStatusCodeMessage(jqXHR,true,'get-insurance-reservation-panding')
                    }
                });
            },

            BackPendingReservationList() {
                var self = this;
                if(self.contractType == ''){

                    self.$router.push("/reservation/rental?active=pending");

                }

                if(self.contractType != '' && self.contractType == 'Rental'){

                self.$router.push("/reservation/rental?active=pending");

                }
                if (self.contractType != '' && self.contractType == 'Lease'){

                    self.$router.push("/reservation/lease?active=pending");

                }
            },

            updateReadingOutOrIn:function (bookingId,truckId,flag) {

                var self = this;
                // $(event.target).closest('div').find('#readingInput'+truckId).toggle();
                var formData = new FormData();
                self.reading_out_msg = "";
                self.reading_in_msg = "";

                self.readingIn = $("#readingIn"+ truckId).val();
                self.readingOut = $("#readingOut" + truckId).val();
                if(flag == 'out'){

                    if (!this.readingOut || this.readingOut <= 0) {
                        self.reading_out_msg = "Reading Out Of Miles Must Be Greater Than 0";
                    }
                    if(this.readingOut && !this.readingOut.match(/^[0-9]*$/)){
                        self.reading_out_msg = "";
                        this.reading_out_msg = "Reading In Of Miles Must Be Numeric";
                    }
                    if (this.readingOut && this.readingOut.match(/^[0-9]*$/) && this.readingOut > 1000000) {
                        self.reading_out_msg = "";
                        self.reading_out_msg = "Reading Out Of Miles Must Be Less Than 1000000";

                        return;
                    }
                    if(self.reading_out_msg == ''){

                        $('#updateReadingOutBtn').text("Processing....");
                        $('#updateReadingOutBtn').attr('disabled',true);
                        formData.append('booking_id',bookingId);
                        formData.append('truck_id',truckId);
                        formData.append('readingOut',self.readingOut);
                        formData.append('flag',flag);
//                        console.log(bookingId + " " + truckId + " " + self.readingOut +" " + flag);

                    }
                }
                if(flag == 'in'){

                    // alert(this.readingOut);
                    if (!this.readingIn || this.readingIn <= 0) {
                        self.reading_in_msg = "Reading In Of Miles Must Be Greater Than 0";
                    }
                    if(this.readingIn && !this.readingIn.match(/^[0-9]*$/)){
                        self.reading_in_msg = "";
                        this.reading_in_msg = "Reading In Of Miles Must Be Numeric";
                        return;
                    }
                    if(this.readingIn && parseInt(self.readingIn) <= parseInt(self.readingOut)){
                        self.reading_in_msg = "";
                        this.reading_in_msg = "Reading In Miles Must Be Greater Than Reading Out Miles";
                        return;
                    }
                    if (this.readingIn && this.readingIn.match(/^[0-9]*$/) && this.readingIn > 1000000) {
                        self.reading_in_msg = "";
                        self.reading_in_msg = "Reading In Of Miles Must Be Less Than 1000000";

                        return;
                    }
                    if(self.reading_in_msg == ''){

                        $('#updateReadingInBtn').text("Processing....");
                        $('#updateReadingInBtn').attr('disabled',true);
                        formData.append('booking_id',bookingId);
                        formData.append('truck_id',truckId);
                        formData.append('readingIn',self.readingIn);
                        formData.append('flag',flag);
//                        console.log(bookingId + " " + truckId + " " + self.readingIn +" " + flag);

                    }else{
                        return;
                    }
                }
                $.ajax({
                    url: process.env.ROOT_API + "/update_reading_out_or_reading_in",
                    type: "POST",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    data: formData,
                    dataType: "json",
                    processData: false,
                    contentType: false,
                    success: function (data) {
                        if(data.status == 'success'){
                            self.GetTruckData(self.reservationId);
                        }
                        if(flag == 'out'){

                            $('#updateReadingOutBtn').text("Save");
                            $('#updateReadingOutBtn').attr('disabled',false);

                            // $("#readingOut"+truckId).val(self.readingOut);
                            $("#reading-out" + truckId).toggle();
                            self.viewReadingOutInput = false;
                            self.readingOutSpan = true;
                            self.editReadingOutInput = true;

                        }
                        if(flag == 'in'){

                            $('#updateReadingInBtn').text("Save");
                            $('#updateReadingInBtn').attr('disabled',false);

                            $("#reading-in" + truckId).toggle();
                            self.readingInText = self.readingIn;
                            self.viewReadingInInput = false;
                            self.readingInSpan = true;
                            self.editReadingInInput = true;

                        }

                    },
                    error: function (jqXHR, exception) {

                        if(flag == 'out'){

                            $('#updateReadingOutBtn').text("Save");
                            $('#updateReadingOutBtn').attr('disabled',false);

                        }
                        if(flag == 'in'){

                            $('#updateReadingInBtn').text("Save");
                            $('#updateReadingInBtn').attr('disabled',false);

                        }

                        self.generateStatusCodeMessage(jqXHR,true,'reding-out-in-reservation-panding')
                    }
                });


            },
            updateReservationDetail:function (reservationId,truckTypeId,flag) {

                var self = this;

                self.refError ="";
                self.statusErr = "";
                if(self.CurrentStatus == null){
                    self.statusErr = 'Status Required';
                    return;
                }
                if(flag == 'status'){
                    if(self.CurrentStatus.value == undefined){
                        self.viewStatusInput = false;
                        self.enrichStatusSpan = true;
                        self.editStatusInput = false;
                        return;
                    }
                }
                if(flag == 'ref_num'){
                    if(self.enrichRefNo == ''){
                        self.refError ="Reference Number Required";
                        return;
                    }
                }


                //change button text on click
                // $('#updateTransBtn').text("Processing....");
                // $('#updateTransBtn').attr('disabled',true);

                $.ajax({
                    url: process.env.ROOT_API + "/update_temp_reservation_detail",
                    type: "POST",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    data: {
                        status:self.CurrentStatus.value,
                        reference_no:self.enrichRefNo,
                        reservationId:reservationId,
                        truckTypeId:truckTypeId,
                        flag:flag
                    },
                    dataType: "json",
                    success: function (data) {

                        // $('#updateTransBtn').text("Save");
                        // $('#updateTransBtn').attr('disabled',false);

                        if(flag == 'status'){
                            self.viewStatusInput = false;
                            self.enrichStatusSpan = true;
                            self.editStatusInput = false;
                        }
                        // self.enrichTransNoText = self.enrichTransNo;
                        if(flag == 'ref_num'){
                            self.viewEnrichInput = false;
                            self.enrichTransNoSpan = true;
                            self.editEnrichInput = true;
                        }

                        self.GetTruckData(reservationId);
                    },
                    error: function (jqXHR, exception) {

                        // $('#updateTransBtn').text("Save");
                        // $('#updateTransBtn').attr('disabled',false);

                        self.generateStatusCodeMessage(jqXHR,true,'update-temp-reservation-panding')
                    }
                });

            },

            viewFile: function (id, path,type) {

                var self = this;
                var folder = "";
                if(type == 'from_their') {
                    folder = "/insurance/";
                }else{
                    folder =  "/insDoc/";
                }

                var api = process.env.ROOT_API.split('/');
                self.Invoicefile = api[0] + '//' + api[2] + folder + path;
                //get image file width and height
                var image = new Image();
                image.src = path;
                image.onload = function () {
                    var imgHeight = this.height;
                    var imgWidth = this.width;
                    if (imgHeight > 0 && imgWidth > 0) {
                        self.$swal({
                            imageUrl: path,
                            imageHeight: imgHeight,
                            imageWidth: imgWidth,
                            imageAlt: type,
                            width:imgWidth,
                            height:imgHeight
                        });
                    }else{
                        self.$swal({
                            imageUrl: path,
                            imageHeight: 1000,
                            imageWidth: 1000,
                            imageAlt: type
                        });
                    }
                }
                // var save = document.createElement('a');
                // save.href = self.Invoicefile;
                // // save.download = self.Invoicefile;
                // save.target = '_blank';
                // document.body.appendChild(save);
                // save.click();
                // document.body.removeChild(save);

            },

            deleteInsuranceFile: function(file_id, reservationId, truckId, flag) {
                var self = this;
                if (confirm('Are you sure that you want to remove file? ')) {

                    self.submitBtn = false;
                    //remove from server if user have already uploaded on server
                    $.ajax({
                        url: process.env.ROOT_API + "/remove_temp_insurance_data",
                        type: "POST",
                        crossDomain: true,
                        data: {id: file_id, reservationId: reservationId,truck_id:truckId,flag:flag},
                        dataType: "json",
                        headers: this.ajxHeaders,
                        success: function (data) {
                            //console.log(data.content[0]["id"]);
                            if (data.status == "success") {
                                //update local storage for files
                                localStorage.setItem("files", JSON.stringify(data.content));
                                //remove file block
                                // $("#fileDiv" + id).remove();

                                self.GetTruckData(reservationId);
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.generateStatusCodeMessage(jqXHR,true,'delete-insurance-file-reservation-panding')
                        }
                    });
                }

                return;

            },


            prevPage: function(){
                var self = this;
                if ( self.role != 'customer' ) {
                    self.$router.push("/listbookings");
                } else {
                    self.$router.push("/reservationhistory");
                }
            },

            cancelbooking: function(id) {
                var self = this;

                if (confirm('Are you sure that you want to cancel this reservation? ')) {

                    //getting comment value for reason of cancellation
                    this.comment = JSON.stringify(result.value);

                    $.ajax({
                        url: process.env.ROOT_API + "/cancel_booking",
                        type: "get",
                        crossDomain: true,
                        dataType: "json",
                        headers: this.ajxHeaders,
                        data: {
                            id:id,
                            comment: self.comment,
                            userid:self.loggedInUser
                        },
                        success: function (data) {
                            //console.log(data.content[0]["id"]);
                            if (data.status == "success") {
                                self.getBookingDetails();
                                console.log(data.content);
                                // self.$router.push("/./listbookings");
                            }
                        },
                        error: function (jqXHR, exception) {
                            // self.$router.push("/./listbookings");
                            self.generateStatusCodeMessage(jqXHR,true,'cancle-booking-reservation-panding')
                        }
                    });
                }

            },
            //Format value to two decimal point
            numberFormat(amount) {
                return parseFloat(amount).toFixed(2);
            },

            getBookingDetails: function(){

                var self =this;
                self.loading = true;
                var date = new Date();
                var offset = date.getTimezoneOffset();
                if (self.view_booking_id != undefined) {
                    //get rental object

                    $.ajax({
                        url: process.env.ROOT_API + "/get_pending_booking_data",
                        type: "GET",
                        crossDomain: true,
                        dataType: "json",
                        headers: this.ajxHeaders,
                        data: {
                            booking_id: self.view_booking_id,
                            offset:offset,
                            role:'customer'
                        },
                        success: function(data) {

                            self.loading = false;

                            //console.log(data.content[0]["id"]);
                            if (data.status == "success") {
                                // console.log(data.content[0].trucks);
                                self.RentedTrucksArr = data.content;

                                if(localStorage.getItem('temp_reservation_id') && localStorage.getItem('temp_reservation_id') != null){
                                    self.GetTruckData(localStorage.getItem('temp_reservation_id'));
                                } else {
                                    self.GetTruckData(self.RentedTrucksArr[0].trucks[0].reservId);
                                }
                                // if(localStorage.getItem('temp_reservation_id') && localStorage.getItem('temp_reservation_id') != null){
                                //     self.GetTruckData(self.view_booking_id,localStorage.getItem('temp_reservation_id'));
                                // }else{
                                //     self.GetTruckData(self.view_booking_id,self.RentedTrucksArr[0].trucks[0].reservId);
                                // }

                            }else{
                                self.RentedTrucksArr = [];
                            }
                        },
                        error: function(jqXHR, exception) {
                            self.loading = false;

                            $("#myModal").modal("hide");
                            if (jqXHR.status == 0) {
                                self.error = "Remote server cannot be reached";
                                // } else if(jqXHR.status == 403) {
                                //     self.$router.push('/listbookings');
                                //     self.$swal('',"You Do Not Have Permission To View Details","error");
                            } else if ( jqXHR.status == 400 ) {
                                $(".container-truck-selection").html("<h1 style='text-align:center;'>No Data Found.</h1>");
                            }else{
                                self.error = jqXHR.responseJSON.message;
                            }
                        }
                    });
                }
            },

            openModal: function(id,booking_id,truck_id ,flag){
                console.log(flag);
                var self = this;
                //reinitialize data
                self.files = [];
                self.calculate = false;
                self.bookingId = booking_id;
                self.truckId = truck_id;
                self.errorDetails = "";
                self.errorothCharges = "";

                if(flag != 'update') {
                    self.modalbtn = 'Add';
                    self.doc_path = "";
                    self.doc_fileArr = [];
                    self.othCharges = "";
                    self.chargesDetails = "";
                    self.files = [];
                    self.chargeId = "";
                    self.fileerroor_msg = "";
                    // self.chargesfield.id = id;
                } else {
                    self.modalbtn = 'Update';
                    self.fileerroor_msg = "";
                }

                // }
                if( flag == 'update' ){

                    self.modalbtn = 'Update';
                    $.ajax({
                        url: process.env.ROOT_API + "/get_charges_details",
                        type: "GET",
                        crossDomain: true,
                        dataType: "json",
                        headers: {
                            'Accept': 'application/json',
                            "Authorization": "Bearer "+localStorage.getItem("tkn"),
                            'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                            "Cache-Control": "no-cache",
                            'flag': 'customer'
                        },
                        data: {
                            charges_id:id
                        },

                        success: function(data) {

                            //console.log(data.content[0]["id"]);
                            if (data.status == "success") {
                                console.log(data.content);
                                self.gallons = data.content.gallons;
                                self.fuelRate = data.content.rate;
                                self.fuelTotal = data.content.amount;
                                self.chargeId = data.content.id;
                                self.othCharges = data.content.othCharges;
                                self.chargesDetails = data.content.chargesDetails;
                                // self.chargesFields.push(data.content);
                                self.files = data.content.doc_path;

                            }
                        },
                        error: function(jqXHR, exception) {
                            $("#myModal").modal("hide");
                            self.generateStatusCodeMessage(jqXHR,true,'get-charges-reservation-panding')
                        }

                    });

                }
                // console.log(truck_id);
                $("#myModal").modal("show");

            },
            handleFilesUpload: function(event) {
                /*
                      Get the uploaded files from the input.
                  */
                // const file = event.target.files[0]
                // // console.log(file);
                var self = this;
                self.fileerroor_msg = "";

                let uploadedFiles = "";
                // console.log(self.$refs.phyfiles);
                self.uploadBtn= "Uploading...";
                uploadedFiles = self.$refs.files.files;
//                console.log(self.$refs.files);

                for (var i = 0; i < uploadedFiles.length; i++) {

                    // if(uploadedFiles[i].size > 5000000){
                    //     // alert('size exceeded'+i);
                    //     self.fileerroor_msg = 'File Size Should Not Be Greater Than 5 MB';
                    //     // $("#fileerror").text('File Size Should Not Be Greater Than 5 MB');
                    // }
                    this.files.push(uploadedFiles[i]);

                }

                //this.$refs.files.value = '';
                self.uploadBtn= "Upload";
                // //this.getImagePreviews();
            },
            updateFuelCharges: function(id) {

                var self = this;
                var booking_id = self.bookingId;
                var truck_id = self.truckId;
                // console.log(self.chargesFields[0].chargesDetails);
                // console.log(self.chargesfield.chargesDetails + "hello");

                // console.log(this.files);
                // return;

                self.errorothCharges = "" ;
                self.errorfuelCharges = "" ;
                self.errorgallonsCharges = "";
                self.errorDetails = "";
                self.fileerroor_msg = "";
                if(self.chargesDetails == ""){
                    self.errorDetails = "Charges Detail Required" ;
                }
                if(self.othCharges == "" && !self.othCharges){

                    self.errorothCharges = "Other Charges Required" ;
                    return;
                }
                if(self.othCharges && !String(self.othCharges).match(/^\d+(\.\d*)?$/) ){
                    self.errorothCharges = "";
                    self.errorothCharges = "Other Charges Must Be Numeric";
                }
                if(self.othCharges && String(self.othCharges).match(/^\d+(\.\d*)?$/) && self.othCharges > 1000000){
                    self.errorothCharges = "";
                    self.errorothCharges = "Other Charges Must Not Be More Than 1000000";
                }

                if(self.errorothCharges == "" && self.errorDetails == "") {

                    var formData = new FormData();
                    formData.append('booking_id',booking_id);
                    formData.append('truck_id', truck_id);

                    formData.append("chargeDetail", self.chargesDetails);
                    formData.append("chargeAmount", self.othCharges);
                    formData.append("chargeId", id);
                    console.log('this one');
                    console.log(this.files);

                    for (var i = 0; i < this.files.length; i++) {
                        let file = this.files[i];

                        if(file.size > 5000000){

                            self.fileerroor_msg = 'File Size Should Not Be Greater Than 5 MB';
                            // return;
                        }
                        if(file.type == "image/jpeg" || file.type == "image/png") {
                        }else{

                            self.fileerroor_msg = 'Only Image Files Are Allowed (.png / .jpeg)';
                            // return;
                        }
                        formData.append("files[]", file);
                    }
                    if( self.fileerroor_msg != ""){
                        return;
                    }
                    if(id != undefined && id != 0){
                        formData.append("flag", 'update');
                    }

                    $('#myButton').text("Processing....");
                    $('#myButton').attr('disabled', true);

                    self.loading = true;

                    $.ajax({
                        url: process.env.ROOT_API + "/update_fuel_charge",
                        type: "POST",
                        crossDomain: true,
                        //dataType: "json",
                        headers: this.ajxHeaders,
                        data : formData,
                        processData: false,
                        contentType: false,

                        success: function (data) {
                            self.loading = false;
                            $('#myButton').text("Submit");
                            $('#myButton').attr('disabled', false);

                            $("#myModal").modal("hide");
                            self.GetTruckData(self.reservationId);
                            // location.reload();
                            //console.log(data.content[0]["id"]);
                            if (data.status == "success") {
                                console.log(data.content);
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            $('#myButton').text("Add");
                            $('#myButton').attr('disabled', false);
                            self.generateStatusCodeMessage(jqXHR,true,'update-fuel-charge-reservation-panding')
                        }
                    });
                }

            },
            SyncData: function(bookingId, truckId, inspectionType) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/sync_data",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,
                    data: {
                        booking_id: bookingId,
                        truck_id: truckId,
                        inspection_type: inspectionType
                    },
                    success: function(data) {
                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {
                            //alert(data.message);
                            // self.truckSelect = data.content;
                            // self.dealership.value = data.content.value;
                            // self.dealership.deal = data.content.text;
                        }
                    },
                    error: function(jqXHR, exception) {
                        self.generateStatusCodeMessage(jqXHR,true,'sync-data-reservation-panding')
                    }
                });
            },
            removeCharge: function(id){
                var self = this;

                if (confirm('Are you sure that you want to remove this? ')) {
                    self.removeField(id);
                    //remove charges
                    this.$swal("Deleted!", "Charges Removed.", "success");
                }

            },
            removeChargesField: function (id,index) {
                var self = this;

                if (confirm('Are you sure that you want to remove this? ')) {

                    if(id != undefined && id != 0){
                        self.removeField(id);
                        Vue.delete(this.chargesFields, this.chargesfield.id);
                    }else{
                        Vue.delete(this.chargesFields, id);
                    }
                    //remove charges
                    this.$swal("Deleted!", "Charges Removed.", "success");
                }

            },

            addChargesRow: function () {
                this.chargesFields.push(Vue.util.extend({}, this.chargesfield))
            },
            removeField: function(id){
                var self = this;

                if (confirm('Are you sure that you want to remove this? ')) {
                    $.ajax({
                        url: process.env.ROOT_API + "/remove_other_charges",
                        type: "POST",
                        crossDomain: true,
                        dataType: "json",
                        headers: this.ajxHeaders,
                        data: {
                            charges_id:id
                        },
                        success: function(data) {
                            //console.log(data.content[0]["id"]);
                            if (data.status == "success") {
                                self.$swal("Deleted!", "Charges Removed.", "success");
                                // self.getBookingDetails();
                                self.GetTruckData(self.reservationId);

                            }
                        },
                        error: function(jqXHR, exception) {
                            self.generateStatusCodeMessage(jqXHR,true,'remove-field-reservation-panding')
                        }
                    });
                }

            },
            viewInvoice:function(id,truckId,flag){

                var self = this;
                if(flag == 'view'){
                    $("#invoice_modal .modal-body").html("");
                    $("#invoice_modal").modal("show");
                }

                this.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/download_invoice",
                    type: "POST",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    data: {
                        booking_id:id,
                        truck_id:truckId,
                        flag:flag,

                    },
                    success: function(data) {
                        self.loading = false;
                        // self.Invoicefile  = data.content;
                        if(flag != 'view'){
                            self.Invoicefile = data.content;
                            var save = document.createElement('a');
                            save.href = self.Invoicefile;
                            save.download = self.Invoicefile;
                            save.target = '_blank';
                            document.body.appendChild(save);
                            save.click();
                            document.body.removeChild(save);
                        }

                        $("#invoice_modal .modal-body").html(data);

                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'view-invoice-reservation-panding')
                    }
                });
            },
            openPreAuthModal: function(bookingId){
                var self = this;
// console.log(bookingId);
                self.bookingId = bookingId;
                self.authToken = true;
                $("#pre_auth_amount_modal").modal("show");
            },
            addPreAuthCharges: function(){
                var self = this;

                self.error = "";
                if(!self.authCharges){
                    self.error = "Charges Required";
                }
                if(self.authCharges && !self.authCharges.match(/^\d+/)){
                    self.error = "";
                    self.error = "Charges Must Be Numeric";
                }
                if(self.error == "") {
                    $.ajax({
                        url: process.env.ROOT_API + "/add_pre_authcharges",
                        type: "POST",
                        crossDomain: true,
                        headers: this.ajxHeaders,
                        data: {
                            booking_id: self.bookingId,
                            charges: self.authCharges
                        },
                        success: function (data) {
                            self.loading = false;
                            if (data.status == 'success') {
                                $("#pre_auth_amount_modal").modal("hide");
                                self.getBookingDetails();
                            };

                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'add-pre-auth-charge-reservation-panding')
                        }
                    });
                }
            },
            paymentProcess: function() {

                var self = this;
                var truck_id = localStorage.getItem('temp_reservation_id');

                self.pay_error = "";
                if(!self.amounttopay){
                    self.pay_error = "Please Enter Amount To Pay";
                    return;
                }
                if(self.amounttopay && self.amounttopay < 1){
                    self.pay_error = "Amount Cannot Be Less Than 1";
                    return;
                }
                if(self.amounttopay && !self.amounttopay.match(/^[0-9 , '.']*$/)){
                    self.pay_error = "Amount to Pay must be Numeric";
                    return;
                }

                self.loading = true;
                $('#payment_process_btn').text("Processing....");
                $('#payment_process_btn').attr('disabled',true);

                $.ajax({
                    url: process.env.ROOT_API + "/process_payment",
                    crossDomain: true,
                    type: "POST",
                    headers: this.ajxHeaders,
                    data: {
                        paymentMethod:'credit_card',
                        bookingId:this.view_booking_id,
                        truckId:truck_id,
                        amount:self.amounttopay,
                        // customer_id:self.checkUser.value,
                        flag:'view'
                    },
                    success: function (data) {

                        self.loading = false;
                        // $('#payment_process_btn').text("Pay");
                        // $('#payment_process_btn').attr('disabled',false);

                        if (data.status == "success") {
                            var uId = data.content.uId.split( '=' );

                            localStorage.setItem("uId",uId[1]);
                            localStorage.setItem("sessionId",data.content.sessionId);
                            localStorage.setItem("bookingRef",data.content.bookingRef);
                            $("#payCurrentAmount").modal('hide');
                            self.$router.push("/payment?viewbookings="+self.bookingId);


                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'payment-process-reservation-panding')
                    }
                });

            },
            viewChargesFile: function(id, path) {
                var self = this;

                self.$swal({
                    imageUrl: process.env.API + "/chargesDoc/" + path,
                    imageHeight: 500,

                    imageAlt: "Charges Summary"
                });


            },
            deleteChargesFile: function(key,id, chargeId,file){

                var self = this;
                if (confirm('Are you sure that you want to remove file? ')) {

                    if(chargeId != '' && chargeId != undefined && id != undefined){

                        self.loading = true;

                        $.ajax({
                            url: process.env.ROOT_API + "/remove_charges_file",
                            type: "POST",
                            crossDomain: true,
                            dataType: "json",
                            headers: this.ajxHeaders,
                            data: {
                                charges_id:chargeId,
                                doc_path:file
                            },
                            success: function(data) {
                                self.loading = false;
                                //console.log(data.content[0]["id"]);
                                if (data.status == "success") {
                                    // this.files.splice(key,id);
                                    self.$swal("Deleted!", "Your file has been deleted.", "success");
                                    self.GetTruckData(self.reservationId);
                                    $("#myModal").modal("hide");
                                    this.$refs.files.value = '';
                                }
                            },
                            error: function(jqXHR, exception) {
                                self.loading = false;
                                self.files.splice(key,1);
                                self.generateStatusCodeMessage(jqXHR,true,'remove-charge-file-reservation-panding')
                            }
                        });

                    } else{

                        this.files.splice(key,1);
                        this.$refs.files.value = '';


                    }
                }

            },

            openReadingoutInput: function(truckId , flag){
                var self = this;
                if(flag == 'out') {
                    $("#readinOutLoaded"+ truckId).hide();
                    $("#editreadingout"+ truckId).hide();
                    //
                    // $("#readingOut"+truckId).val("");
                    self.reading_out_msg = "";
                    $("#reading-out" + truckId).toggle();
                }if(flag == 'in'){
                    $("#readinInLoaded"+ truckId).hide();
                    $("#editreadingin"+ truckId).hide();
                    // $("#readingIn"+truckId).val("");
                    self.reading_in_msg = "";
                    $("#reading-in" + truckId).toggle();
                }

                if(flag == 'closein') {
                    $("#readinInLoaded"+ truckId).show();
                    $("#editreadingin"+ truckId).show();
                    $("#reading-in" + truckId).toggle();

                    // self.GetTruckData(self.reservationId);

                }
                if(flag == 'closeout'){
                    $("#readinOutLoaded"+ truckId).show();
                    $("#editreadingout"+ truckId).show();
                    $("#reading-out" + truckId).toggle();
                    // self.GetTruckData(self.reservationId);
                }

                // self.viewReadingOutInput = true;
            },
            deleteSelectedTruck: function (reservationId, truckId, event) {
                var self = this;
                console.log(truckId);
                console.log(self.truck_id);
                console.log(reservationId);

                this.$swal({
                    title: "Are you sure?",
                    text: "Reason Of Remove",
                    type: "warning",
                    input: "textarea",
                    showCancelButton: true,
                    confirmButtonText: "Confirm",
                    cancelButtonText: "Close",
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then(result => {
                    if(result.value == ''){
                        result.value = 'No Reason';
                    }
                    if (result.value) {

                        //getting comment value for reason of cancellation
                        this.comment = JSON.stringify(result.value);

                        $.ajax({
                            url: process.env.ROOT_API + "/remove_temp_selected_trucks",
                            type: "POST",
                            crossDomain: true,
                            data: {truck_id: truckId, reservationId: reservationId,reason:this.comment},
                            dataType: "json",
                            success: function (data) {
                                //console.log(data.content[0]["id"]);
                                if (data.status == "success") {
                                    self.$swal("", "Reservation Cancelled.", "success");
                                    self.getBookingDetails(reservationId);
                                    // location.reload();
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.generateStatusCodeMessage(jqXHR,true,'remove-selected-truck-reservation-panding')
                            }
                        });

                    } else if (result.dismiss) {
                        // self.$router.push("/./listbookings");
                    }
                });

            },
            updateReservation: function(bookingId){
                var self = this;

                var string = "&for=pendingReservation&resId="+bookingId+"&action=update"+"&url_type=pending";
                this.$router.push({ name: 'MakeReservation', query: { data : btoa(string) }});
                // localStorage.setItem('booking_id',bookingId);
                // localStorage.setItem('truck_id',truckId);
                // localStorage.setItem('unit_number',unit_no);
                // localStorage.setItem('truck_type',type_id);
                // localStorage.setItem('miles',miles);
                // localStorage.setItem('customer_id',customer_id);

                // self.$router.push({ path:'/trucks' + '?flag=editView'});

            },

            addTruck: function(bookingId,custId){
                var self = this;

                localStorage.setItem('booking_id',bookingId);
                localStorage.setItem('customer_id',custId);

                localStorage.removeItem('truck_id');
                self.$router.push({ path:'/' + '?flag=addTruck'});
            },
            handleDocUpload:function(event){
                var self = this;
                self.insDocToken = false;
                // const file = event.target.files[0]
                // console.log(file);

                // self.selectedFile = file;
                // self.submitBtn = true;
                // console.log(self.selectedFile);


                var uploadedinsFiles = "";
                uploadedinsFiles =  event.target.files;
//                console.log("in.....",uploadedinsFiles);

                for (var i = 0; i < uploadedinsFiles.length; i++) {
                    self.selectedFile.push(uploadedinsFiles[i]);
                }
                // console.log(self.$refs.selectedFile[0].value);
                // self.$refs.selectedFile[0].value = '';
                event.target.value = "";
            },
            handleinsFilesUpload: function(flag) {

                var self = this;

                var uploadedinsFiles = "";
                uploadedinsFiles = self.$refs.phyFiles[0].files;
//                console.log("in.....",uploadedinsFiles);

                for (var i = 0; i < uploadedinsFiles.length; i++) {
                    self.insfile.push(uploadedinsFiles[i]);
                }
                console.log(self.$refs.phyFiles[0].value);
                self.$refs.phyFiles[0].value = '';
                // console.log(self.$refs.$phyFiles[0]);

//                var self = this;
//
//                let uploadedinsFiles = "";
//                if (type == "physical") {
//                    // alert("hello");
//                    const file = event.target.files[0]
//                    console.log(file);
//
//                    self.insfile = file;
//                    self.submitBtn = true;
//
//                } else {
//                    // self.uploadliaBtn= "Uploading...";
//                    const file = event.target.files[0]
//                    console.log(file);
//
//                    self.liafile = file;
//                    self.submitBtn = true;
//                    console.log(self.insfile);
//
//                }


            },
            submitFiles(id,flag,bookingId,reservationId,pickup_date,drop_date) {

                var self = this;
                var error = false;
                var formData = new FormData();

                self.insDocerrors = "";
                self.phypolicyerrors = "";
                self.phynumbererrors = "";
                self.phycompanyerrors = "";
                self.phyDocerrors = "";
                self.phyemailerrors = "";

                if ( flag == 'from_their' ) {


                    if ( self.insfile != null ) {
                        console.log(self.insfile.length);

                        if(self.insfile.length > 3){
                            self.phyDocerrors = 'Only Three Files Allowed At A Time';
                            error = true;
                            return;
                        }

                        for (var i = 0; i < self.insfile.length; i++) {

                            let file = this.insfile[i];

                            if ( file.size > 5000000 ) {
                                self.phyDocerrors = 'File size should not be greater than 5 MB';
                                error = true;
                            }
                            // if ( file.type == "image/jpeg" || file.type == "image/png" ) {
                            // } else {
                            //     self.phyDocerrors = 'Only image files are allowed (.png / .jpeg)';
                            //     error = true;
                            // }

                            if ( self.phyDocerrors == "" ) {
                                formData.append("physicalFiles[]", file);
                            }
                        }
                    }

                    if ( self.phyContactNo && !String(self.phyContactNo).match(/^[0-9]*$/) ) {
                        self.phynumbererrors = "Contact number must be numeric";
                        error = true;
                    }
                    if ( self.phyContactNo && (self.phyContactNo.length < 10 || self.phyContactNo.length > 12 ) ) {
                        self.phynumbererrors = "Contact number must be between 10 to 12 digits";
                        error = true;
                    }
                    if ( self.phyEmail && !self.validEmail(self.phyEmail) ) {
                        self.phyemailerrors = "Enter valid Email.";
                        error = true;
                    }

                    formData.append("physicalinstype", 'from_their');
                    if(self.phyCompanyName == null){
                        self.phyCompanyName = "";
                    }
                    if (self.phyCompanyName != '' && self.phyCompanyName.text != undefined ) {
                        formData.append("phyCompanyId", self.phyCompanyName.value );
                    } else {
                        formData.append("phyCompanyId", '');
                    }

                    if(self.insCompany == null){
                        self.insCompany = "";
                    }

                    if (self.insCompany != "" && self.insCompany.value != undefined ) {
                        formData.append("custPolicyId", self.insCompany.value );
                    } else {
                        formData.append("custPolicyId", '');
                    }

                    formData.append("phyContactNo", self.phyContactNo);
                    formData.append("phyContactName", self.phyContactName);
                    formData.append("phyEmail", self.phyEmail);
                    formData.append("phyPolicyNo", self.phyPolicyNo);

                }

                self.insDocerrors = "";

                if(flag == 'from_us'){

                    if (self.selectedFile.length > 0) {

                        for (var i = 0; i < self.selectedFile.length; i++) {
                            self.insDocerrors = "";

                            let file = this.selectedFile[i];

                            if ( file.size > 5000000 ) {
                                self.insDocerrors = 'File size should not be greater than 5 MB';
                                error = true;
                            }
                            // if ( file.type == "image/jpeg" || file.type == "image/png" ) {
                            // } else {
                            //     self.phyDocerrors = 'Only image files are allowed (.png / .jpeg)';
                            //     error = true;
                            // }

                            if ( self.insDocerrors == "" ) {
                                formData.append("physicalinstype", 'from_us');
                                formData.append("insDoc[]", file);
                            }
                        }

                        // if (self.selectedFile.size > 5000000) {
                        //     self.insDocerrors = "";
                        //     self.insDocerrors = 'File size should not be greater than 5 MB';
                        //     error = true;
                        // }
                        // else if(self.selectedFile.type != "image/jpeg" && self.selectedFile.type != "image/png"){
                        //     self.insDocerrors = "";
                        //     self.insDocerrors = 'Only image files are allowed (.png / .jpeg)';
                        //     error = true;
                        // }
                        //  else {

                        //     formData.append("physicalinstype", 'from_us');
                        //     formData.append("insDoc[]", self.selectedFile);
                        // }

                    }


                }



                if ( error == false )
                {

                    formData.append('pickup_date',pickup_date);
                    formData.append('dropoff_date',drop_date);
                    formData.append("booking_id", bookingId);
                    formData.append("reservation_id", reservationId);
                    formData.append("flag", flag);


                    console.log(formData);

                    self.loading = true;

                    $.ajax({
                        url: process.env.ROOT_API + "/store_temp_insurance_data",
                        type: "POST",
                        crossDomain: true,
                        processData: false,
                        contentType: false,
                        data: formData,
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function(data) {
                            self.loading = false;

                            //console.log(data.content[0]["id"]);
                            if (data.status == "success") {
                                self.GetTruckData(reservationId);

                                console.log('thisone');

                                if(flag == 'from_their'){
                                    self.insfile = [];
                                    // self.$refs.phyfiles.value = "";
                                }

                                if(flag == 'from_us'){

                                    self.selectedFile = [];
                                    self.insDocToken = true;
                                    console.log(self.selectedFile);
                                }
                                self.errors.push(data.message);

                            } else if (data.status == "error") {

                                if (data.content.phyContactNo) {
                                    self.phynumbererrors.push("Physical damage Contact Number must be of 10 digit");
                                    self.loading=false;
                                }
                                if (data.content.phyCompanyName) {
                                    self.phycompanyerrors.push(data.content.phyCompanyName);
                                    self.loading=false;
                                }

                                console.log($(".error_style").length);
                                self.msgClass = "error";
                            }

                        },
                        error: function(jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'store-temp-insurance-file-reservation-panding')
                        }
                    });
                } else {

                    console.log($(".error_style").length);
                    self.msgClass = "error";
                }
            },
            deleteFromUsDoc: function(key){
                var self = this;
                self.insDocToken = true;
//                self.selectedFile = [];
                self.selectedFile.splice(key, 1);
                self.submitBtn = false;
            },
            deleteInsuranceDoc: function(id, key,event) {
                var self = this;

                if (confirm('Are you sure that you want to remove file? ')) {
                    self.submitBtn = false;

                    this.insfile.splice(key,1);
                    self.$refs.phyFiles[0].value = '';
                }

                return;
                /*
                  check file already uploaded on server or not
              */
            },

            openUpload: function(id){
                var self = this;

                $("#uploadForm"+id).toggle();
            },
            openUpdateinput: function(id,flag){
                var self = this;

                if(flag == 'company'){
                    // self.viewEditComForm = true;
                    $('#phycompany'+id).show();
                }
                if(flag == 'contact'){
                    // self.viewEditComForm = true;
                    $('#phycontact'+id).show();
                }
                if(flag == 'liacompany'){
                    // self.viewEditComForm = true;
                    $('#liacompany'+id).show();
                }
                if(flag == 'liacontact'){
                    // self.viewEditComForm = true;
                    $('#liacontact'+id).show();
                }
                if(flag == 'comclosein'){
                    self.phycompanyerror = "";
                    // self.viewEditComForm = true;
                    $('#phycompany'+id).hide();
                }
                if(flag == 'conclosein'){
                    self.phycontacterror = "";
                    // self.viewEditComForm = true;
                    $('#phycontact'+id).hide();
                }
                if(flag == 'liacomclosein'){
                    self.liacompanyerror = "";
                    // self.viewEditComForm = true;
                    $('#liacompany'+id).hide();
                }
                if(flag == 'liaconclosein'){
                    self.liacontacterror = "";
                    // self.viewEditComForm = true;
                    $('#liacontact'+id).hide();
                }

            },
            updateCompanyDetails: function(bookingId,truckId,flag , field){
                var self = this;

                var formData = new FormData();

                formData.append('booking_id',bookingId);
                formData.append('truck_id',truckId);
                self.phycomapnyerror = "";
                self.phycontacterror = "";
                if(flag == 'physical'){
                    formData.append('flag',flag);
                    if(field == 'company'){
                        if(!self.physcompanyName){
                            self.phycompanyerror = 'Company Name Required';
                        }

                        if(self.phycompanyerror == ""){
                            formData.append('phycompanyName',self.physcompanyName);
                        }else{
                            return;
                        }
                    }
                    if(field == 'contact'){
                        if(!self.contactNum){
                            self.phycontacterror = 'Contact Number Required';
                        }
                        if(self.contactNum && !self.contactNum.match(/^[0-9]*$/)){
                            self.phycontacterror = "";
                            self.phycontacterror = 'Contact Number Must Be Numeric';
                        }
                        if(self.contactNum && self.contactNum.match(/^[0-9]*$/) && self.contactNum.length < 10 || self.contactNum.length > 12){
                            self.phycontacterror = "";
                            self.phycontacterror = 'Contact Number Must Of 10 Digits';
                        }

                        if(self.phycontacterror == ''){
                            formData.append('phycontactnum',self.contactNum);
                        }else{
                            return;
                        }
                    }
                }
                self.liacompanyerror = "";
                self.liacontacterror = "";
                if(flag == 'liability') {
                    formData.append('flag', flag);
                    if (field == 'company') {
                        if (!self.liabcompanyName) {
                            self.liacompanyerror = 'Company Name Required';
                        }
                        if (self.liacompanyerror == '') {
                            formData.append('liacompanyName', self.liabcompanyName);
                        } else {
                            return;
                        }
                    }
                    if (field == 'contact') {
                        if (!self.liacontactNum) {
                            self.liacontacterror = 'Contact Number Required';
                        }
                        if (self.liacontactNum && !self.liacontactNum.match(/^[0-9]*$/)) {
                            self.liacontacterror = "";
                            self.liacontacterror = 'Contact Number Must Be Numeric';
                        }
                        if (self.liacontactNum && self.liacontactNum.match(/^[0-9]*$/) && self.liacontactNum.length < 10 || self.liacontactNum.length > 12) {
                            self.liacontacterror = "";
                            self.liacontacterror = 'Contact Number Must Be Of 10 Digits';
                        }
                        if (self.liacontacterror == '') {
                            formData.append('liacontactnum', self.liacontactNum);
                        } else {
                            return;
                        }
                    }
                }
                $.ajax({
                    url: process.env.ROOT_API + "/change_insurance_detail",
                    type: "POST",
                    processData: false,
                    contentType: false,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    data: formData,
                    dataType: "json",
                    success: function (data) {
                        //console.log(data.content[0]["id"]);
                        if (data.status == "success") {
                            if(flag == 'physical'){
                                if(field == 'company'){
                                    $('#phycompany'+truckId).hide();
                                }else{
                                    $('#phycontact'+truckId).hide();
                                }
                            }
                            if(flag == 'liability'){
                                if(field == 'company'){
                                    $('#liacompany'+truckId).hide();
                                }else{
                                    $('#liacontact'+truckId).hide();
                                }
                            }
                            self.GetTruckData(self.reservationId);
                            // location.reload();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.generateStatusCodeMessage(jqXHR,true,'change-insurance-reservation-panding')
                    }
                });
            },
            GetTruckData: function(reservation_id){

                var self =this;
                self.reservationId = reservation_id;
                self.viewEnrichInput = false;
                self.enrichTransNoSpan = true;
                self.editEnrichInput = true;
                self.loading = true;
                var date = new Date();
                var offset = date.getTimezoneOffset();
                var temp_reservation_id = localStorage.getItem('temp_reservation_id');
                if (self.view_booking_id != undefined) {

                    $.ajax({
                        url: process.env.ROOT_API + "/get_pending_truck_data",
                        type: "GET",
                        crossDomain: true,
                        dataType: "json",
                        headers: {
                            'Accept': 'application/json',
                            "Authorization": "Bearer "+localStorage.getItem("tkn"),
                            'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                            "Cache-Control": "no-cache",
                            "flag":''
                        },
                        data: {
                            reservation_id: reservation_id,
                            //truck_id:truck_id,
                            offset:offset,
                            role:'customer'
                        },
                        success: function(data) {

                            //display truck bedge selected
                            $(".truck-badge").removeClass("active");
                            $("#truck_badge_"+reservation_id).addClass("active");

                            // localStorage.setItem('truck_id',truck_id);
                            self.loading = false;
                            // console.log(data.content[0]["id"]);
                            if (data.status == "success") {
                                console.log(data.content[0].lia_insurance_type);
                                self.TrucksArr = data.content;
                                var storeObject={visited_page: {
                                    path : "pending-reservation |" +data.content[0].reference_no,
                                    data : window.location.pathname,
                                }};
                                self.getRecentlyPagesMethod(storeObject);
                                self.companyArr = data.content[0].customer_policies;
                                self.contractType = data.content[0].contractType;
                                var instype = data.content[0].lia_insurance_type;

                                if(instype == ''){
                                    self.instype = {value : '',text : ""};
                                }else{
                                    if(instype == 'from_their'){
                                        self.fromTheir = true;
                                        // self.instype.value = 'from_their';
                                        // self.instype.text = "Having Third Party Insurance";
                                        self.instype = {value : 'from_their',text : "Having Third Party Insurance"};

                                    }else{
                                        self.fromTheir = false;
                                        self.instype = {value : 'from_us',text : "Do Not Have Third Party Insurance"};
                                    }
                                }


                                var phyinstype = data.content[0].phy_insurance_type;
                                /* if(phyinstype == ''){
                                    self.phyinstype = {value : '',text : ""};
                                }else{
                                    if(phyinstype == 'from_their'){
                                        self.phyfromTheir = true;
                                        // self.phyinstype.value = 'from_their';
                                        // self.phyinstype.text = "Having Third Party Insurance";
                                        self.phyinstype = {value : 'from_their',text : "Having Third Party Insurance"};
                                        self.insuranceType = 1;
                                    }else{
                                        self.insuranceType = 0;
                                        self.phyfromTheir = false;
                                        self.phyinstype = {value : 'from_us',text : "Do Not Have Third Party Insurance"};
                                    }
                                } */

                                self.insuranceRates= data.content[0].insurance_rates;
                                if ( phyinstype == 'from_their') {

                                    self.phyfromTheir = true;
                                    self.insuranceType = 1;

                                    if( data.content[0].phyinsfiles ) {

                                        //if policy is selected than display selected
                                        if ( data.content[0].phyinsfiles[0].policy_id ) {
                                            self.insCompany = {'value':data.content[0].phyinsfiles[0].policy_id,'text':data.content[0].phyinsfiles[0].policy_name };
                                        }

                                        setTimeout(function(){
                                            self.phyContactNo = self.formatPhoneNumber(data.content[0].phyinsfiles[0].contact_number);
                                            if ( data.content[0].phyinsfiles[0].company_id != "" ) {
                                                self.phyCompanyName = {'text':data.content[0].phyinsfiles[0].company,'value':data.content[0].phyinsfiles[0].company_id};
                                            }

                                            self.phyContactName = data.content[0].phyinsfiles[0].contact_name;
                                            self.phyEmail = data.content[0].phyinsfiles[0].email;
                                            self.phyPolicyNo = data.content[0].phyinsfiles[0].policy_number;
                                        },1000);

                                    } else {
                                        //set defalut null when update insurance type
                                        self.phyContactNo = "";
                                        self.phyCompanyName = [];
                                        self.phyContactName = "";
                                        self.phyEmail = "";
                                        self.phyPolicyNo = "";
                                    }

                                } else {
                                    self.insuranceType = 0;
                                    self.phyfromTheir = false;
                                }

                                self.readingIn = data.content[0].readingIn;
                                self.readingOut =  data.content[0].readingOut;

                                if(self.readingIn > 0 && self.readingOut > 0){
                                    self.readingToken = true;
                                }else{
                                    self.readingToken = false;
                                }
                                self.currentReservationAmt = data.content[0].total;
                                var amtType = data.content[0].actual;

                                if(amtType == 'true'){
                                    self.amtType = 'Actual'
                                }else{
                                    self.amtType = 'Estimated';
                                }
                                localStorage.removeItem("temp_reservation_id");

                            }
                        },
                        error: function(jqXHR, exception) {
                            self.loading = false;
                            $("#myModal").modal("hide");
                            self.generateStatusCodeMessage(jqXHR,true,'get-truck-reservation-panding')
                        }
                    });
                }

            },
            storeActualTotal: function(bookingId){
                var self = this;
                var date = new Date();
                var offset = date.getTimezoneOffset();
                $.ajax({
                    url: process.env.ROOT_API + "/store_actual_total",
                    type: "POST",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    data: {booking_id:bookingId,truck_id:localStorage.getItem('temp_reservation_id'),offset:offset},
                    dataType: "json",
                    success: function (data){

                        self.GetTruckData(self.reservationId);
                    },
                    error: function (jqXHR, exception) {
                        self.generateStatusCodeMessage(jqXHR,true,'store-total-reservation-panding')
                    }
                });
            },
            openPaymentModal:function(bookingId){
                var self = this;
                self.pay_error = '';
                $("#payCurrentAmount").modal('show');

                self.loading = true;
                self.bookingId = bookingId;
                $.ajax({
                    url: process.env.ROOT_API + "/get_outstanding_amount",
                    type: "GET",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    data: {
                        booking_id: bookingId,
                        truck_id:localStorage.getItem('temp_reservation_id')
                    },
                    success: function (data) {
                        self.loading = false;
                        if (data.status == 'success') {

                            self.outstandingAmt = self.numberFormat(data.content);
                            // self.currentReservationAmt = self.numberFormat(data.content.total);
                            self.amounttopay = self.numberFormat(data.content);

                        };

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'opren-payment-reservation-panding')
                    }
                });

            },
            validEmail: function(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
            },
            getReservationStatus:  function(){
                var self = this;

                self.loading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/get_reservation_status",
                    type: "GET",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    success: function (data) {
                        self.loading = false;
                        if (data.status == 'success') {

                            self.statusArr = data.content;
                        };

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'get-status-reservation-panding')
                    }
                });
            }
        }
    };
</script>
<style scope>

    .chargecontent{
        text-align: right;
    }
    .btnClass{
        display: block;
        width:30%;
        background-color: red;
        border-color: red;
        /*vertical-align: middle;*/
        border: 1px solid transparent;
        border-top-color: transparent;
        border-right-color: transparent;
        border-bottom-color: transparent;
        border-left-color: transparent;
        border-radius: 4px;
        line-height: 2.12857143;
        float: right;
        color: #f6f6f6;
    }
    #updateStatusBtn{
        position:relative;
    }
    .left-section span {
        font-size: 12px;
        float: left;
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Reservation/PendingReservationContent.vue